const startHelpChatButton = document.querySelectorAll(".start-help-chat-link");
startHelpChatButton.forEach((button) =>
  button.addEventListener("click", (e) => {
    e.preventDefault();
    // eslint-disable-next-line no-undef
    zE("messenger", "open");
  }),
);
